import { useEffect, useState, useCallback } from "react";

declare const __BUILD_VERSION__: string;

const POLL_INTERVAL = 60_000; // check every 60 seconds

export function useNewVersionCheck() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  const checkVersion = useCallback(async () => {
    // Only check in production builds where __BUILD_VERSION__ is defined
    if (typeof __BUILD_VERSION__ === "undefined") return;

    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, {
        cache: "no-store",
      });
      if (!res.ok) return;
      const data = await res.json();
      if (data.version && data.version !== __BUILD_VERSION__) {
        setNewVersionAvailable(true);
      }
    } catch {
      // Network error or offline — ignore
    }
  }, []);

  useEffect(() => {
    if (typeof __BUILD_VERSION__ === "undefined") return;

    const interval = setInterval(checkVersion, POLL_INTERVAL);
    // Also check when the tab becomes visible again
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkVersion();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [checkVersion]);

  return newVersionAvailable;
}
